const ZENDESK_KEY = 'c226ac7a-ad52-42d9-9510-8ea9d2bdc5e6'
const ZENDESK_TICKET_FORM_ID = 14500070598039
let zendeskLoaded = false

export const loadZendesk = () => {
  if (zendeskLoaded) return
  zendeskLoaded = true

  window.zESettings = {
    webWidget: {
      contactForm: {
        ticketForms: [{ id: ZENDESK_TICKET_FORM_ID }],
      },
    },
  }

  const script = document.createElement('script')
  script.id = 'ze-snippet'
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`
  script.onload = () => {
    window.zE('webWidget', 'hide')
    window.dispatchEvent(new Event('zendeskReady'))
  }
  document.body.appendChild(script)
}
